import { render, staticRenderFns } from "./redDute.vue?vue&type=template&id=2619405e&scoped=true&"
import script from "./redDute.vue?vue&type=script&lang=js&"
export * from "./redDute.vue?vue&type=script&lang=js&"
import style0 from "./redDute.vue?vue&type=style&index=0&id=2619405e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2619405e",
  null
  
)

export default component.exports